import { useEffect, useState } from "react";
import { SSIUplineResponse } from "../../services/SSIUpline/ssiUplineAPI.types";
import { lambdaErrorCheck } from "../../common/util/errorHandling";
import { useAppSelector } from "../../store";
import { storedLocale } from "../Authentication/util";
import { useGetSSIUplineAPIQuery } from "../../services/SSIUpline/ssiUplineAPI";

export const defaultSSIUplineData = (): SSIUplineResponse => {
  return {
    PreWindow: {
      Periods: [],
    },
    InWindow: {
      InPaymentMonth: [],
      InSSIProgram: [],
    },
    OutOfProgram: {
      ABOs: [],
    },
    EarnedPayment: {
      Groups: [],
    },
    CallResults: [],
    Error: [],
  };
};

export const FetchSSIUplineData = (overridePeriod: string) => {
  const { user } = useAppSelector((state) => state.boot);
  const shellConfig = useAppSelector((state) => state.boot.shellConfig);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetSSIUplineAPIQuery({
    Abo: user.abo,
    Aff: user.aff,
    OverridePeriod: overridePeriod,
    IsoCountryCode: user.isoCountryCode,
    IsoCurrencyCode: shellConfig.isoCurrencyCode,
    Locale: storedLocale(),
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [ssiUplineData, setSsiUplineData] = useState<SSIUplineResponse>(defaultSSIUplineData());

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setSsiUplineData(payloadData);
      const foundLambdaError = lambdaErrorCheck(payloadData.Error);
      setErrorStatus(foundLambdaError);
    }
  }, [isFetching, overridePeriod, isError, payloadData]);

  return { isLoading, ssiUplineData, errorStatus, refetch };
};
